/**
 * Ships browser errors to the backend sink (POST /monitoring/client-errors).
 *
 * Deliberately dependency-light and fail-safe: it uses raw fetch (NOT apiClient)
 * because the very thing that failed may be auth/apiClient, and it must never
 * throw from inside an error boundary. Auth is inferred server-side from the
 * cookie/token, so we just send with credentials and swallow any failure.
 */
const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8000/api/v1';
const APP_VERSION = import.meta.env.VITE_APP_VERSION || 'unknown';

export interface ClientErrorPayload {
  message?: string;
  stack?: string;
  component_stack?: string;
  variant?: 'component' | 'route' | 'global';
  source?: 'auto' | 'user';
  extra?: Record<string, unknown>;
}

export async function reportClientError(payload: ClientErrorPayload): Promise<void> {
  try {
    await fetch(`${API_URL}/monitoring/client-errors`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      // keepalive lets the request survive a navigation/reload right after a crash.
      keepalive: true,
      body: JSON.stringify({
        ...payload,
        url: window.location.href,
        user_agent: navigator.userAgent,
        app_version: APP_VERSION,
      }),
    });
  } catch {
    // Never let error reporting throw — it runs from inside an error boundary.
  }
}
